import React from 'react';
import ProductContext from './ProductContext';

export default class ProductProvider extends React.Component {
  state = {
    products: [],
    collects: [],
    total:[],
    loading: false,
  };

  render() {
    return (
      <ProductContext.Provider
        value={{
          products: this.state.products,
          collects: this.state.collects,
          total: this.state.total,
          loading: this.state.loading,
          setProducts: (products) => {
            if (products !== this.state.products) this.setState({ products });
          },
          setCollects: (collects) => {
            if (collects !== this.state.collects) this.setState({ collects });
          },
          setTotal: (total) => {
            if (total !== this.state.total) this.setState({ total });
          },
          setLoading: (loading) => {
            if (loading !== this.state.loading) this.setState({ loading });
          },
        }}
      >
        {this.props.children}
      </ProductContext.Provider>
    );
  }
}
